
































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { CmsStore } from '@/stores/cms.store';
import { EventKey } from '@/util/EventKey';
import { FooterTopLinkDto, ImageLinkDto, MenuDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import CmsImageLink from '@/views/cms/snippet/CmsImageLink.vue';

@Component({
  components: {CmsImageLink, CmsLink},
})
export default class Footer extends Vue {
  private cmsStore = getModule(CmsStore, this.$store);

  public async mounted(): Promise<void> {
    this.$events.$on(EventKey.INITIAL_LANGUAGE, this.fetchFooterIfNecessary);
    this.$events.$on(EventKey.LANGUAGE_CHANGE, this.fetchFooterIfNecessary);
  }

  private async fetchFooterIfNecessary(language: string): Promise<void> {
    await this.cmsStore.fetchFooterIfNecessary(language);
  }

  public get topLinks(): FooterTopLinkDto[] {
    return this.cmsStore.footer?.topLinks ?? [];
  }

  public get bottomLinks(): MenuDto[] {
    return this.cmsStore.footer?.bottomLinks ?? [];
  }

  public get extraImages(): ImageLinkDto[] {
    return this.cmsStore.footer?.extraImages ?? [];
  }
}
